<div class="credits-card">
  <div class="credits-card-header">
    <div class="credits-card-title">
      <h5>
        {{ 'company-tool.snippets.credits-counter.title' | transloco }}
      </h5>
      @if (autoRenewalActive()) {
        <ct-lib-tag>
          <fa-icon
            class="me-1"
            [icon]="fontawesomeService.light.repeat"
          ></fa-icon>
          {{
            'company-tool.snippets.credits-counter.auto-renewal-tag'
              | transloco
                : {
                    date: autoRenewalEnabledAt() | date: 'longDate',
                  }
          }}
        </ct-lib-tag>
      }
    </div>

    @if (isAdmin()) {
      <div class="credits-card-actions">
        <app-button
          variant="white-grey"
          [iconStart]="fontawesomeService.light.clockRotateLeft"
          [ariaLabel]="
            'company-tool.snippets.credits-counter.log-link' | transloco
          "
          (click)="openCreditsLog($event)"
        ></app-button>
        <app-button
          variant="white-grey"
          [iconStart]="fontawesomeService.light.creditCard"
          (click)="openCreditsBookingModal()"
        >
          {{
            'company-tool.snippets.credits-counter.booking-button' | transloco
          }}
        </app-button>
      </div>
    }
  </div>

  <p-meterGroup
    class="credits-card-meter"
    [value]="meterValue()"
    [min]="0"
    [max]="meterMax()"
    orientation="horizontal"
    labelPosition="end"
    labelOrientation="horizontal"
  >
    <ng-template #label let-meters>
      <ul class="credits-legend">
        @for (item of meters; track item.label) {
          <li>
            <span
              class="credits-legend-marker"
              [style.backgroundColor]="item.color"
              aria-hidden="true"
            ></span>
            <span class="credits-legend-label">{{ item.label }}</span>
            <b class="credits-legend-value">{{
              item.value | number: '1.0-0'
            }}</b>
          </li>
        }
      </ul>
    </ng-template>
  </p-meterGroup>

  <div class="credits-card-footer">
    @if (nextCreditsResetAmount() > 0 && nextCreditsResetDate(); as resetDate) {
      <p class="credits-card-reset">
        {{
          'company-tool.snippets.credits-counter.reset-date'
            | transloco
              : {
                  count: nextCreditsResetAmount() | number: '1.0-0',
                  date: resetDate | date: 'longDate',
                }
        }}
      </p>
    }
    @if (showPaymentLink()) {
      <div class="credits-card-links">
        <a
          class="credits-card-payment-link"
          [routerLink]="['/settings', 'company', 'payment']"
          (click)="onPaymentLinkClick($event)"
        >
          {{ 'company-tool.snippets.credits-counter.payment-link' | transloco }}
          <fa-icon [icon]="fontawesomeService.light.chevronRight"></fa-icon>
        </a>
      </div>
    }
  </div>
</div>
